import { render } from "./change-password.vue?vue&type=template&id=5372f9ca"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"

import "./change-password.vue?vue&type=style&index=0&id=5372f9ca&lang=postcss"
script.render = render

export default script